import { arrayUnion, arrayRemove } from "firebase/firestore";
import { updateUser } from ".";

/**
 * Agrega un ID de historia a la lista de historias del usuario.
 * @param {string} storyId - ID de la historia a agregar.
 * @returns {Promise<object>} Datos actualizados del usuario.
 */
export const addToCollection = (storyId) => {
  if (!storyId) return;

  return updateUser({
    storyIds: arrayUnion(storyId),
  });
};

/**
 * Elimina un ID de historia de la lista de historias del usuario.
 * @param {string} storyId - ID de la historia a eliminar.
 * @returns {Promise<object>} Datos actualizados del usuario.
 */
export const removeFromCollection = (storyId) => {
  if (!storyId) return;

  return updateUser({
    favorites: arrayRemove(storyId),
    storyIds: arrayRemove(storyId),
  });
};
